import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Загрузить шаблон',
      title: 'Загрузить шаблоны АТК',
      executeAction: 'Загрузить',
      cancelAction: 'Отмена',
      selectFiles: 'Выбрать файлы',
      sendToGisMt: 'Отправить в ГИС МТ',
      filesSelected: 'Выбрано файлов: %{count} (макс. %{max})',
      successMessage: 'Все файлы успешно загружены',
      partialSuccessMessage: 'Часть файлов загружена с ошибками',
      errorMessage: 'Ошибка загрузки',
      status: {
        pending: 'Ожидание',
        uploading: 'Загружается',
        success: 'Загружен',
        error: 'Ошибка',
      },
    },
  },
};
